<template>
  <v-container class="ma-0 pa-0 mw-100">
    <v-container :class="`text-${$vuetify.breakpoint.name}-h5`" :style="styleObject()" class="text-uppercase ma-0 pa-0 mw-100">{{ text }}</v-container>
    <v-container class="ma-0 pa-0 mw-100" id="divider" style="background-color: rgb(150, 150, 150); height: 1px; width:100%;"></v-container>
  </v-container>
</template>

<script>/**
 * @vue-prop {String} title - title content
 */

export default {
  name: "HeaderMedium",
  props: {
    text: String
  },
  methods: {
    styleObject() {
      return {
        color: this.$vuetify.theme.themes.light.primary
      };
    },
  },
};
</script>